<template>
  <div>
    <v-container>
      <h1 class="headline mb-3 mt-3">History Live</h1>

      <!-- ถ้าไม่มี history ใช้อันนี้ -->
      <div v-if="loading" class="text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div
          v-if="!endeditem || !endeditem.length"
          class="caption grey--text text-xs-center my-3"
        >No history live</div>
        <div v-else>
          <div class="text-xs-right">
            <v-pagination
              class="mb-2"
              @input="changepage"
              v-model="page"
              :length="pagelength"
              :total-visible="7"
            ></v-pagination>
          </div>
          <div v-if="pageloading" class="text-xs-center">
            <v-progress-circular indeterminate :size="32" :width="4" color="primary"></v-progress-circular>
          </div>
          <div v-else>
            <div v-for="(item, k) in endeditem" :key="k" class="z-border-red px-2 py-2 mb-2">
              <v-layout wrap>
                <!-- <v-flex xs12 sm2 class="text-xs-center pt-2 pb-2">
                  <v-chip small color="red " dark style="opacity: 0.5">
                    <v-icon small class="mr-2">stop</v-icon>Stop
                  </v-chip>
                </v-flex>-->
                <v-flex xs6 sm3 class="text-xs-center">
                  <div class="caption pt-1">Start Live</div>
                  <div
                    class="primary--text caption pt-1 pb-2"
                  >{{ item.startlive | DateFormat('DD/MM/YYYY HH:mm') }}</div>
                </v-flex>
                <v-flex xs6 sm3 class="text-xs-center">
                  <div class="caption pt-1">End Live</div>
                  <div
                    class="primary--text caption pt-1 pb-2"
                  >{{ item.endlive | DateFormat('DD/MM/YYYY HH:mm') }}</div>
                </v-flex>
                <v-flex xs6 sm2 class="text-xs-center">
                  <div class="caption pt-1">Engagement</div>
                  <div class="primary--text title pt-1 pb-2">{{ item.engagement }}</div>
                </v-flex>
                <v-flex xs6 sm2 class="text-xs-center">
                  <div class="caption pt-1">Orders</div>
                  <div class="primary--text title pt-1 pb-2">{{ item.orders }}</div>
                </v-flex>
                <v-flex xs12 class="hidden-sm-and-up py-2">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm2 class="text-xs-center text-sm-right">
                  <v-btn @click="showOrderHistory(item.id)" small outline color="primary">view order</v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </v-container>
    <v-dialog width="800px" v-model="showorderhistory" persistent>
      <v-card v-if="showorderhistory">
        <div class="text-xs-right">
          <v-btn icon @click="closeOrderHistory">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="pt-0">
          <OrderSummary ref="orderhistory" :liveid="historyid"></OrderSummary>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import OrderSummary from './OrderSummary'

export default {
  data() {
    return {
      data: [],
      loading: false,
      pageloading: false,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 1,
      limit: 10,
      showorderhistory: false,
    }
  },
  components: {
    OrderSummary,
  },
  async mounted() {
    this.loading = true
    await this.getLiveInfo()
    this.loading = false
  },
  computed: {
    ...mapGetters(['selectedBot']),
    endeditem() {
      if (this.data) {
        return this.data.filter((el) => ['ended'].includes(el.status))
      } else {
        return []
      }
    },
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / 10)
      } else {
        return 1
      }
    },
  },
  methods: {
    closeOrderHistory() {
      this.showorderhistory = false
      this.$refs.orderhistory.destroyInterval()
    },
    showOrderHistory(id) {
      this.historyid = id
      this.showorderhistory = true
    },
    changepage(val) {
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getLiveInfo()
      }
    },
    getLiveInfo() {
      var vm = this
      return new Promise((resolve, reject) => {
        this.pageloading = true
        vm.offset = vm.page * 10 - 10
        if (vm.page != 1) {
          vm.offset + 1
        }
        api.getliveinfoHistory(
          { pageid: this.selectedBot.pageid, limit: this.limit, offset: vm.offset },
          (err, response) => {
            this.pageloading = false
            if (response && response.responsecode == 200) {
              if (response.data) {
                this.data = response.data
                this.liveid = response.data[0].id
                this.pagetotal = response.total
                resolve()
              } else {
                this.createNew()
                resolve()
              }
            }
          }
        )
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/live/HistoryLive.vue